document.addEventListener('DOMContentLoaded', function() {
    const videoContainers = document.querySelectorAll('.video-overlay-container');

    videoContainers.forEach(container => {
        const video = container.querySelector('.video-player');
        const overlay = container.querySelector('.video-overlay');

        if (video && video.hasAttribute('autoplay')) {
            hideOverlay(overlay);
        }

        overlay.addEventListener('click', function() {
            playVideo(video, overlay);
        });

        video.addEventListener('ended', function() {
            showOverlay(overlay);
        });

        video.addEventListener('pause', function() {
            if (!video.ended) {
                showOverlay(overlay);
            }
        });

        const isIOS = /iPad|iPhone|iPod|Safari/.test(navigator.userAgent);
        if (isIOS) {
            video.load();
        }
    });
});

function playVideo(video, overlay) {
    hideOverlay(overlay);
    video.play().catch(error => {
        console.error('Fehler beim Abspielen des Videos:', error);
        showOverlay(overlay);
    });
}

function hideOverlay(overlay) {
    overlay.classList.add('hidden');
}

function showOverlay(overlay) {
    overlay.classList.remove('hidden');
}
